module.exports = __webpack_public_path__ + "static/media/logo-tchibo.ea021a9f.svg";